import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';
import { bindActionCreators } from 'multireducer';

import MobileCarousel from './mobile-carousel/mobile-carousel';
import firstTimeTrackAnimation from './first-time-track-animation/first-time-track-animation';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { isExternalVideo } from '@wix/wix-vod-shared/src/common/ui-selectors/video/video-origin';
import { loadMore } from 'widget/redux/client/actions/channel-videos-lazy-load';

import { MOBILE_WIDGET_DATA_KEY } from 'widget/data-components/lazy-channel-videos';
import { VIDEOS_COUNT_MOBILE_SLIDER } from 'mobile/constants/layout';

import fetchVideoUrls from 'widget/redux/client/actions/video-urls/fetch';


@connect(
  state => ({
    videoIds: state.lazyVideoLists[MOBILE_WIDGET_DATA_KEY].videoIds,
    videoByIds: getVideosGroupedByIds(state),
    currentSiteUser: getCurrentSiteUser(state),
    nextVideosCursor: state.lazyVideoLists[MOBILE_WIDGET_DATA_KEY].nextVideosCursor,
  }),
  dispatch => ({
    // it's because of we are using multireducer
    ...bindActionCreators({
      loadMore,
    }, dispatch, MOBILE_WIDGET_DATA_KEY),
    ...bindActionCreators({
      fetchVideoUrls,
    }, dispatch),
  })
)
@firstTimeTrackAnimation
export default class SlidableListWithLazyLoad extends React.Component {

  static propTypes = {
    videoIds: PropTypes.array,
    videoByIds: PropTypes.object,
    onUserStartedTracking: PropTypes.func,
    className: PropTypes.string,
    trackClassName: PropTypes.string,
    currentSiteUser: PropTypes.object,
    nextVideosCursor: PropTypes.string,

    loadMore: PropTypes.func,
    itemHeight: PropTypes.number,
    onCurrentSlideChanged: PropTypes.func,
    fetchVideoUrls: PropTypes.func,
    selectedVideoId: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.element),
  };

  static defaultProps = {
    onCurrentSlideChanged: _.noop,
  };

  componentWillReceiveProps(nextProps) {
    this.preloadUrls(nextProps.videoByIds);
  }

  preloadUrls(videos) {
    _.forEach(videos, videoItem => this.fetchUrlsForVideo(videoItem));
  }

  fetchUrlsForVideo(videoItem) {
    const { fetchVideoUrls, currentSiteUser } = this.props;

    // TODO: Need to move this logic out of view
    // See the same in PlayerWrapper
    if (videoItem) {
      if (!isExternalVideo(videoItem)) {
        if (!videoItem.memberOnly || currentSiteUser) {
          fetchVideoUrls(videoItem);
        }
      }
    }
  }

  @autobind
  @debounce(50)
  afterChange(leftVisibleSlideIndex) {
    const { onCurrentSlideChanged } = this.props;

    this.loadMore(leftVisibleSlideIndex + 1);
    onCurrentSlideChanged(leftVisibleSlideIndex);
  }

  get selectedIndex() {
    const { videoIds, selectedVideoId } = this.props;

    const selectedVideoIndex = _.indexOf(videoIds, selectedVideoId);
    return selectedVideoIndex < 0 ? 0 : selectedVideoIndex;
  }

  @autobind
  loadMore(slidesShown) {
    const { nextVideosCursor, loadMore, videoIds } = this.props;
    const threshold = VIDEOS_COUNT_MOBILE_SLIDER / 2;

    if (nextVideosCursor && (_.size(videoIds) - slidesShown) < threshold) {
      return loadMore(VIDEOS_COUNT_MOBILE_SLIDER, nextVideosCursor);
    }
  }

  render() {
    const { className, itemHeight, trackClassName, onUserStartedTracking, children } = this.props;

    return (
      <MobileCarousel afterChange={this.afterChange}
                      getHeight={_.constant(itemHeight)}
                      showButtons={false}
                      onUserStartedTracking={onUserStartedTracking}
                      slidesToShow={1}
                      trackClassName={trackClassName}
                      className={className}
                      initialSlide={this.selectedIndex}>
        {children}
      </MobileCarousel>
    );
  }
}




// WEBPACK FOOTER //
// ./src/mobile/views/home/components/slidable-list-with-lazy-load.js